/*
 * Jira Ticket:
 * Created Date: Mon, 23rd Mar 2020, 10:58:41 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Datagrid, List, TextField, useTranslate, Title } from 'react-admin';
import { connect } from 'react-redux';
import ListActions from './actions';
import ListFilter from './filter';
import { FilteredEmploymentProjectOrganisationField } from 'Components/Fields';
import { isSuperAdmin, isProjectManager, isSelf } from 'utils/roles';
import { PostPagination } from '../../Components/CustomPagination/pagination';
import { usePersistentOrganisation } from '../../Components/Contexts';

const redirectToFirstTab = (permissions, userId) => {
  if (permissions) {
    if (!isSuperAdmin(permissions)) {
      return isProjectManager(permissions) || isSelf(userId);
    }
  }
  return false;
};

const UserList = ({ listValues, dispatch, ...props }) => {
  const { permissions } = props;
  const translate = useTranslate();
  const superAdmin = isSuperAdmin(permissions);

  const {
    persistentOrganisation,
    onSelectPersistentOrganisation,
  } = usePersistentOrganisation();

  return (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        filterDefaultValues={{
          organisationId: persistentOrganisation.id,
          status: 'active',
        }}
        title={translate('resources.User.name', { smart_count: 2 })}
        bulkActionButtons={false}
        perPage={25}
        pagination={<PostPagination />}
        exporter={false}
        actions={<ListActions organisationId={persistentOrganisation?.id} />}
        filters={
          <ListFilter
            isAdmin={isSuperAdmin(permissions)}
            organisationFilter={onSelectPersistentOrganisation}
            organisationId={persistentOrganisation?.id}
          />
        }
        {...props}
      >
        <Datagrid
          rowClick={(id, basePath, record) => {
            if (superAdmin) {
              if (redirectToFirstTab(permissions, record.id)) {
                return `/User/${record.id}/1`;
              }
              return `/User/${record.id}`;
            } else if (!record.isAdmin) {
              if (redirectToFirstTab(permissions, record.id)) {
                return `/User/${record.id}/1`;
              }
              return `/User/${record.id}`;
            }
          }}
        >
          <TextField
            source="email"
            label={'resources.User.fields.email'}
            sortable={false}
          />
          {/* isAdmin = true will always have empty assignedProjects and assignedOrganisations arrays */}
          <FilteredEmploymentProjectOrganisationField
            label={'resources.User.fields.assignedProjects'}
            source="assignedProjects"
            {...props}
          />
          <FilteredEmploymentProjectOrganisationField
            label={'resources.User.fields.organisations'}
            source="assignedOrganisations"
            {...props}
          />
          <TextField
            label={'resources.User.fields.UserStatus'}
            source="status"
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  );
};

const mapStateToProps = state => {
  return {
    listValues: state.admin.resources.User && state.admin.resources.User.data,
  };
};

export default connect(mapStateToProps)(UserList);
